// this simply returns a unique key to distinguish requests according to filters

const getCacheKey = (
    packCode: string,
    startDate: string | null,
    endDate: string | null,
    season: string,
    participants: number[],
    skipass?: number | null,
    origin?: string | null
): string => {
    const parts = [
        packCode,
        startDate ?? "",
        endDate ?? "",
        season,
        participants.join(",")
      ]
      if (skipass != null) {
        parts.push(`skipass${skipass}`)
      }
      if(origin) {
        parts.push(`origin${origin}`)
      }
      return parts.join(" - ")
}

export default getCacheKey

